import Cookie from '@/utils/cookie';
import { LANG, LANG_IDS, NOTIFY_LANG } from '@/constants';
import { SSRContext } from 'vue/server-renderer';

export default class LangManager {
  static initialized = false;

  static init() {
    if (this.initialized || import.meta.env.SSR) {
      return;
    }
    this.initialized = true;
    /**
     * path:
     * 1. '/live/101'
     * 2. '//live/101'
     * 3. /invalid_lang/live/101
     * 4. '/en/live/101'
     */
    // const reg = /^(\/.*)*?(\/live\/\d+)$/;
    const reg = /^(\/.*)*?(\/live.*)$/;
    const path = location.pathname;
    const mat = path.match(reg);
    if (mat) {
      const mat1 = mat[1];
      const mat2 = mat[2];

      // 1. '/live/101';
      if (mat1 === undefined) {
        const newPathname = '/' + this.get() + mat2;
        const newHref = location.href.replace(location.pathname, newPathname);
        return location.replace(newHref);
      }

      const lang = mat1.split('/')[1];

      // 2. '//live/101'  &&  3. /invalid_lang/live/101
      if (!this.isValid(lang)) {
        const newPathname = '/' + this.get() + mat2;
        const newHref = location.href.replace(location.pathname, newPathname);
        return location.replace(newHref);
      }

      // 4. '/en/live/101'
      this.set(lang);
    }
  }

  static set(lang: string) {
    if (this.isValid(lang)) {
      Cookie.set('bstar-web-lang', lang, { domain: '.bilibili.tv', path: '/' });
      // bstar_c_locale、bstar_s_locale 提供给广播多语言场景使用
      Cookie.set('bstar_c_locale', lang, { domain: '.bilibili.tv', path: '/' });
      Cookie.set('bstar_s_locale', lang, { domain: '.bilibili.tv', path: '/' });
    }
  }

  static get() {
    return Cookie.get('bstar-web-lang') || 'en';
  }

  static getID() {
    const lang = this.get();
    return LANG_IDS[lang];
  }

  static refresh(lang: string) {
    this.set(lang);
    const newUrl = location.href.replace(/\/(en|th|id|vi|ms)\//, `/${lang}/`);
    location.replace(newUrl);
  }

  static isValid(lang: string) {
    return Object.keys(LANG).includes(lang);
  }

  static getSLocal(context?: SSRContext) {
    const lang: string = (context ? context.lang : this.get()) || 'en';
    const sLocale = NOTIFY_LANG[lang];
    return sLocale;
  }
}
